export default __webpack_public_path__ + "static/media/cal-options.da54718b.png";